"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _distributionStore = require("@/api/distributionStore");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DistributionStoreContract',
  data: function data() {
    return {
      loading: false,
      list: [],
      previewVisible: false,
      previewLoading: false,
      previewTitle: '合同预览',
      previewUrl: '',
      blobUrl: '',
      previewError: ''
    };
  },
  created: function created() {
    this.load();
  },
  beforeDestroy: function beforeDestroy() {
    this.revoke();
  },
  methods: {
    load: function load() {
      var _this = this;
      this.loading = true;
      (0, _distributionStore.storeMineContractsApi)().then(function (list) {
        _this.list = list || [];
      }).catch(function () {}).finally(function () {
        _this.loading = false;
      });
    },
    /** OSS 默认域名会强制下载 PDF，先取成 Blob 再以 application/pdf 内嵌显示 */preview: function preview(row) {
      var _this2 = this;
      this.revoke();
      this.previewTitle = row.contractName || '合同预览';
      this.previewUrl = row.fileUrl;
      this.previewError = '';
      this.previewVisible = true;
      this.previewLoading = true;
      fetch(row.fileUrl).then(function (res) {
        if (!res.ok) throw new Error(String(res.status));
        return res.blob();
      }).then(function (blob) {
        _this2.blobUrl = URL.createObjectURL(new Blob([blob], {
          type: 'application/pdf'
        }));
      }).catch(function () {
        _this2.previewError = '无法在线加载合同（文件服务器未允许跨域访问），请点「新窗口打开」查看或下载。';
      }).finally(function () {
        _this2.previewLoading = false;
      });
    },
    revoke: function revoke() {
      if (this.blobUrl) URL.revokeObjectURL(this.blobUrl);
      this.blobUrl = '';
    },
    openNew: function openNew() {
      var url = this.blobUrl || this.previewUrl;
      if (url) window.open(url, '_blank');
    }
  }
};